export const clinicalMessages = {
  "en": {
    "clinical.noteLoading": "Loading the saved clinical note…",
    "clinical.noteLoadFailed": "The saved clinical note could not be checked. Reload before editing.",
    "clinical.notePending": "No clinician-approved final note yet",
    "clinical.noteApproved": "Clinician-approved final note",
    "clinical.noteDraftContext": "Use saved draft as context (not final)",
    "clinical.noteDraftSelected": "Clinician-selected draft source — not a final clinical note",
    "clinical.noteVersion": "Clinical note provenance",

    "clinical.photos.title": "Patient photos",
    "clinical.photos.loading": "Checking Patient-granted EHR access…",
    "clinical.photos.required": "Patient approval through Request EHR is required to view photos.",
    "clinical.photos.unavailable": "Photo access could not be checked. Return to the appointment to retry.",
    "clinical.photos.empty": "No patient photos shared yet.",
    "clinical.photos.back": "Back to appointment",
    "clinical.photos.readonly": "Photos are read-only for clinicians and require active Patient-granted EHR access.",
    "clinical.title": "Clinical outputs",
    "clinical.sick_note": "Sick Note",
    "clinical.prescription": "Prescription assistance",
    "clinical.lab_request": "Tests / Labs request",
    "clinical.referral": "Referral handover",
    "clinical.lab_review": "Result review",
    "clinical.intro": "Draft, review and approve each output. Fola never issues a clinical document independently.",
    "clinical.text": "Clinical content / indication",
    "clinical.test": "Requested test",
    "clinical.from": "Absence from",
    "clinical.through": "Absence through",
    "clinical.apply": "Use reviewed draft in this form",
    "clinical.save": "Save draft",
    "clinical.review": "Confirm clinician review",
    "clinical.finalise": "Approve and finalise",
    "clinical.close": "Close editor",
    "clinical.draft": "Draft",
    "clinical.reviewed": "Reviewed",
    "clinical.finalised": "Finalised",
    "clinical.edit": "Review / edit",
    "clinical.amend": "Create amendment",
    "clinical.loading": "Loading clinical records…",
    "clinical.error": "This action could not be completed. Your saved records are preserved. Check required fields or refresh before retrying.",
    "clinical.retry": "Refresh records",
    "clinical.empty": "No clinical outputs yet.",
    "clinical.help": "Clinical outputs and secure exchange help",
    "clinical.assist": "Use finalised VitalRep™ context",
    "clinical.assisted": "Context copied from your finalised consultation note. Review it; select medicines and doses yourself in the prescription workflow.",
    "clinical.noSource": "No finalised VitalRep™ note is available for this appointment.",
    "clinical.native": "Continue to final review and signing",
    "clinical.immutable": "Final version — changes require a new amendment.",
    "clinical.print": "Print / save PDF",
    "clinical.myEhr": "Clinical documents and results",
    "clinical.mock": "Controlled lab test — synthetic results, not for clinical use.",
    "clinical.consent": "Allow this approved request and its result to be exchanged with the controlled mock lab for seven days. No other myEHR records are shared.",
    "clinical.allow": "Allow this exchange",
    "clinical.revoke": "Revoke exchange consent",
    "clinical.waiting": "Waiting for Patient consent in myEHR.",
    "clinical.send": "Send to controlled mock lab",
    "clinical.received": "Result received",
    "clinical.queued": "Queued",
    "clinical.sending": "Sending",
    "clinical.blocked": "Exchange blocked",
    "clinical.manual_attention": "Review required",
    "clinical.unreviewed": "Result awaiting clinician review",
    "clinical.reviewResult": "Draft result review",
    "clinical.audit": "Audit history",
    "clinical.draft_saved": "Draft saved",
    "clinical.clinician_reviewed": "Clinician reviewed",
    "clinical.patient_exchange_consent": "Patient consent granted",
    "clinical.patient_exchange_revoked": "Patient consent revoked",
    "clinical.exchange_queued": "Exchange queued",
    "clinical.exchange_claimed": "Delivery started",
    "clinical.exchange_retry": "Delivery eligible for retry",
    "clinical.exchange_blocked": "Delivery blocked",
    "clinical.lab_result_received": "Lab result received",
    "clinical.date": "Finalised on",
    "clinical.by": "Clinician",
    "clinical.version": "Version reference",
    "clinical.awaiting": "Availability pending",
    "clinical.photos.accessTitle": "Photo and EHR access",
    "clinical.photos.accessInfo": "You own your photos. Approve EHR requests in the appointment. Clinicians can only read your photos during active access; you can revoke it here without deleting images.",
    "clinical.photos.pending": "EHR access requested",
    "clinical.photos.active": "Patient-approved access",
    "clinical.photos.revoke": "Revoke access",
    "clinical.photos.appointment": "Appointment reference",
    "clinical.noteTests": "Tests/labs mentioned in consultation note",
    "clinical.orderState": "Request status",
    "clinical.order_ordered": "Ordered",
    "clinical.order_sent": "Sent",
    "clinical.order_collected": "Collected",
    "clinical.order_resulted": "Result returned",
    "clinical.order_cancelled": "Cancelled",
    "clinical.externalRequest": "Lab request reference",
    "clinical.requestReference": "Linked request version",
    "clinical.cancelOrder": "Cancel request",
    "clinical.cancelReason": "Cancellation reason",
    "clinical.confirmCancel": "Confirm cancellation",
    "clinical.lab_ordered": "Request ordered",
    "clinical.lab_sent": "Request sent",
    "clinical.lab_collected": "Sample collected (adapter evidence)",
    "clinical.lab_resulted": "Result linked to request",
    "clinical.lab_cancelled": "Request cancelled",
    "clinical.suggestionOnly": "Fola draft suggestion from recorded consultation context. Check relevance and edit before review. Nothing is issued.",
    "clinical.useSuggestion": "Use suggestion in draft",
    "clinical.discardSuggestion": "Discard suggestion",
    "clinical.suggestionLong": "This context exceeds the document limit. Shorten it in the draft before saving.",
    "clinical.catalogueOnly": "Matching catalogue concepts only. Market authorisation and stock are unverified. Select and check the medicine and dose in the prescription form.",
    "clinical.voice.start": "Amend draft by voice",
    "clinical.voice.stop": "Stop dictation",
    "clinical.voice.unavailable": "On-device dictation is unavailable in this browser or language. Type your amendment instead; no audio was sent to an external speech service.",
    "clinical.voice.preview": "Review dictated amendment",
    "clinical.voice.apply": "Apply amendment to draft",
    "clinical.voice.discard": "Discard dictation",
    "clinical.summaryAssist": "Suggest patient / follow-up summary",
    "clinical.summarySource": "Uses the current plan and follow-up text. Review and finalise through VitalRep."
  },
  "fr": {
    "clinical.noteLoading": "Chargement de la note clinique enregistrée…",
    "clinical.noteLoadFailed": "La note clinique enregistrée n’a pas pu être vérifiée. Rechargez avant de la modifier.",
    "clinical.notePending": "Aucune note finale approuvée par le clinicien",
    "clinical.noteApproved": "Note finale approuvée par le clinicien",
    "clinical.noteDraftContext": "Utiliser le brouillon enregistré comme contexte (non final)",
    "clinical.noteDraftSelected": "Brouillon choisi par le clinicien — ce n’est pas une note finale",
    "clinical.noteVersion": "Provenance de la note clinique",

    "clinical.photos.title": "Photos du patient",
    "clinical.photos.loading": "Vérification de l’accès au dossier autorisé par le patient…",
    "clinical.photos.required": "L’accord du patient via la demande d’accès au dossier est requis pour voir les photos.",
    "clinical.photos.unavailable": "L’accès aux photos n’a pas pu être vérifié. Revenez au rendez-vous pour réessayer.",
    "clinical.photos.empty": "Aucune photo partagée par le patient pour le moment.",
    "clinical.photos.back": "Retour au rendez-vous",
    "clinical.photos.readonly": "Les photos sont en lecture seule pour les cliniciens et nécessitent une autorisation active du patient.",
    "clinical.title": "Documents cliniques",
    "clinical.sick_note": "Certificat médical",
    "clinical.prescription": "Aide à la prescription",
    "clinical.lab_request": "Demande d’examens / analyses",
    "clinical.referral": "Orientation et transmission",
    "clinical.lab_review": "Examen du résultat",
    "clinical.intro": "Rédigez, examinez et approuvez chaque document. Fola ne délivre jamais de document clinique de façon autonome.",
    "clinical.text": "Contenu clinique / indication",
    "clinical.test": "Examen demandé",
    "clinical.from": "Absence du",
    "clinical.through": "Absence jusqu’au",
    "clinical.apply": "Utiliser le brouillon vérifié dans ce formulaire",
    "clinical.save": "Enregistrer le brouillon",
    "clinical.review": "Confirmer l’examen clinique",
    "clinical.finalise": "Approuver et finaliser",
    "clinical.close": "Fermer l’éditeur",
    "clinical.draft": "Brouillon",
    "clinical.reviewed": "Examiné",
    "clinical.finalised": "Finalisé",
    "clinical.edit": "Examiner / modifier",
    "clinical.amend": "Créer un avenant",
    "clinical.loading": "Chargement des documents cliniques…",
    "clinical.error": "Cette action n’a pas pu aboutir. Vos documents enregistrés sont conservés. Vérifiez les champs requis ou actualisez avant de réessayer.",
    "clinical.retry": "Actualiser les documents",
    "clinical.empty": "Aucun document clinique pour le moment.",
    "clinical.help": "Aide : documents cliniques et échanges sécurisés",
    "clinical.assist": "Utiliser le contexte VitalRep™ finalisé",
    "clinical.assisted": "Contexte copié depuis votre note de consultation finalisée. Examinez-le ; sélectionnez vous-même les médicaments et les doses dans le parcours de prescription.",
    "clinical.noSource": "Aucune note VitalRep™ finalisée n’est disponible pour ce rendez-vous.",
    "clinical.native": "Poursuivre vers la vérification finale et la signature",
    "clinical.immutable": "Version finale — toute modification nécessite un nouvel avenant.",
    "clinical.print": "Imprimer / enregistrer en PDF",
    "clinical.myEhr": "Documents et résultats cliniques",
    "clinical.mock": "Test de laboratoire contrôlé — résultats fictifs, non destinés aux soins.",
    "clinical.consent": "Autorisez l’échange de cette demande approuvée et de son résultat avec le laboratoire de test contrôlé pendant sept jours. Aucun autre document myEHR n’est partagé.",
    "clinical.allow": "Autoriser cet échange",
    "clinical.revoke": "Retirer le consentement",
    "clinical.waiting": "En attente du consentement du patient dans myEHR.",
    "clinical.send": "Envoyer au laboratoire de test",
    "clinical.received": "Résultat reçu",
    "clinical.queued": "En attente",
    "clinical.sending": "Envoi en cours",
    "clinical.blocked": "Échange bloqué",
    "clinical.manual_attention": "Examen nécessaire",
    "clinical.unreviewed": "Résultat en attente d’examen clinique",
    "clinical.reviewResult": "Rédiger l’examen du résultat",
    "clinical.audit": "Historique d’audit",
    "clinical.draft_saved": "Brouillon enregistré",
    "clinical.clinician_reviewed": "Examiné par le clinicien",
    "clinical.patient_exchange_consent": "Consentement du patient accordé",
    "clinical.patient_exchange_revoked": "Consentement du patient retiré",
    "clinical.exchange_queued": "Échange mis en attente",
    "clinical.exchange_claimed": "Envoi démarré",
    "clinical.exchange_retry": "Nouvel envoi possible",
    "clinical.exchange_blocked": "Envoi bloqué",
    "clinical.lab_result_received": "Résultat reçu",
    "clinical.date": "Finalisé le",
    "clinical.by": "Clinicien",
    "clinical.version": "Référence de version",
    "clinical.awaiting": "Disponibilité en attente",
    "clinical.photos.accessTitle": "Accès aux photos et au dossier",
    "clinical.photos.accessInfo": "Vos photos vous appartiennent. Approuvez les demandes dans le rendez-vous. Les cliniciens peuvent uniquement les consulter pendant un accès actif ; retirez cet accès ici sans supprimer vos images.",
    "clinical.photos.pending": "Accès au dossier demandé",
    "clinical.photos.active": "Accès autorisé par le patient",
    "clinical.photos.revoke": "Retirer l’accès",
    "clinical.photos.appointment": "Référence du rendez-vous",
    "clinical.noteTests": "Examens/analyses mentionnés dans la note de consultation",
    "clinical.orderState": "État de la demande",
    "clinical.order_ordered": "Prescrit",
    "clinical.order_sent": "Envoyé",
    "clinical.order_collected": "Prélèvement effectué",
    "clinical.order_resulted": "Résultat retourné",
    "clinical.order_cancelled": "Annulé",
    "clinical.externalRequest": "Référence de la demande au laboratoire",
    "clinical.requestReference": "Version de la demande liée",
    "clinical.cancelOrder": "Annuler la demande",
    "clinical.cancelReason": "Motif d’annulation",
    "clinical.confirmCancel": "Confirmer l’annulation",
    "clinical.lab_ordered": "Demande prescrite",
    "clinical.lab_sent": "Demande envoyée",
    "clinical.lab_collected": "Prélèvement confirmé par l’adaptateur",
    "clinical.lab_resulted": "Résultat lié à la demande",
    "clinical.lab_cancelled": "Demande annulée",
    "clinical.suggestionOnly": "Proposition Fola issue du contexte enregistré. Vérifiez sa pertinence et modifiez-la avant examen. Aucun document n’est délivré.",
    "clinical.useSuggestion": "Utiliser la proposition dans le brouillon",
    "clinical.discardSuggestion": "Écarter la proposition",
    "clinical.suggestionLong": "Ce contexte dépasse la limite du document. Raccourcissez le brouillon avant de l’enregistrer.",
    "clinical.catalogueOnly": "Concepts correspondants du catalogue uniquement. Autorisation du marché et stock non vérifiés. Sélectionnez et vérifiez le médicament et la dose dans la prescription.",
    "clinical.voice.start": "Modifier le brouillon à la voix",
    "clinical.voice.stop": "Arrêter la dictée",
    "clinical.voice.unavailable": "La dictée locale est indisponible dans ce navigateur ou cette langue. Saisissez votre modification ; aucun audio n’a été envoyé à un service vocal externe.",
    "clinical.voice.preview": "Vérifier la modification dictée",
    "clinical.voice.apply": "Appliquer au brouillon",
    "clinical.voice.discard": "Supprimer la dictée",
    "clinical.summaryAssist": "Proposer un résumé patient / suivi",
    "clinical.summarySource": "Reprend le plan et le suivi actuels. Vérifiez puis finalisez dans VitalRep."
  }
};
export const getClinicalMessage=(lang,key)=>clinicalMessages[String(lang).startsWith("fr")?"fr":"en"][key];
